<ngx-simplebar>
  <div class="spinner" *ngIf="!url">
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>
  <iframe *ngIf="url"
    sandbox="allow-forms allow-modals allow-orientation-lock allow-pointer-lock allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts allow-top-navigation allow-top-navigation-by-user-activation"
    width="100%" height="calc(100vh - 50px)" [src]="url" frameborder="0" data-simplebar>
  </iframe>
</ngx-simplebar>